import React from "react";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {CheckBoxItem} from "../../../../Components/Inputs/CheckboxField";
import {HtmlDisplay} from "../../../../Components/Display";
import {Button} from "../../../../Components/Inputs";

interface BraillerQueueItemProps {
    details: string;
    handleDelete?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue: boolean;
    isSelected?: boolean;
    braillerCatalogItemId: string;
    braillerQueueId: string;
    title: string;
    [key: string]: unknown;
}

export const BraillerQueueItem = ({
                                      details,
                                      handleDelete,
                                      handleSelectedItemsChange,
                                      isPendingQueue,
                                      isSelected,
                                      braillerCatalogItemId,
                                      braillerQueueId,
                                      title,
                                  }: BraillerQueueItemProps) => {

    return <>
        <GridContainer className={`catalog__item`} hasMarginX>

            <GridCell small_columns={gridConstants.column.TWO} medium_columns={gridConstants.column.ONE}>
                {
                    isPendingQueue &&
                    <CheckBoxItem checked={isSelected} hideLabel label={`Select ${title}`}
                                  name={`cb${braillerQueueId}`}
                                  onChange={handleSelectedItemsChange} value={braillerQueueId || ''}/>
                }
            </GridCell>
            <GridCell small_columns={gridConstants.column.TEN} medium_columns={gridConstants.column.ELEVEN}>
                <h3 className={`margin--bottomNone`}>{title}</h3>
                <HtmlDisplay html={details}/>
                {
                    handleDelete &&
                    <Button isCollapsed label={`Cancel Request`} name={`btnDelete${braillerCatalogItemId}`}
                            onClick={handleDelete}/>
                }
            </GridCell>
        </GridContainer>
    </>;
};
